// extracted by mini-css-extract-plugin
export var entityChip = "_sv-0";
export var entityChipMissing = "_sv-1";